module.exports = __webpack_public_path__ + "static/media/07.08.ac966c6d.webp";